import { render } from "./RegisterEmailVerifyView.vue?vue&type=template&id=236a4a34"
import script from "./RegisterEmailVerifyView.vue?vue&type=script&lang=js"
export * from "./RegisterEmailVerifyView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__